@if (type === 'drillings') {
    <div class="workarea-list" [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
        <h1>Details boorkernen</h1>
        @for (workarea of filteredWorkareas; track workarea) {
            <div
                class="workarea"
                [class.break-after]="workareaPerPage"
                [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
                <div class="title">
                    <h2>
                        Boorkern {{ workarea.number }} - {{ workarea.street }} {{ workarea.housenumber }}
                        {{ workarea.place }}
                    </h2>
                    <h4>
                        <a
                            href="http://www.google.com/maps/place/{{ workarea.lat }},{{ workarea.lng }}"
                            target="_blank">
                            {{ workarea.lat }}, {{ workarea.lng }}
                        </a>
                    </h4>
                </div>
                @if (workarea.images?.length > 0) {
                    <div class="image">
                        @for (image of workarea.images; track image) {
                            <img src="{{ image.image_url }}?thumb=true" class="float-start" height="200" width="200" />
                        }
                    </div>
                }
                <div class="details">
                    <table [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
                        <tr>
                            <td width="140">Boorlocatie:</td>
                            <td>{{ workarea.extra?.drillLocation }}</td>
                        </tr>
                        <tr>
                            <td>Rijstrook:</td>
                            <td>{{ workarea.extra?.lane }}</td>
                        </tr>
                        <tr>
                            <td>Lengte boorkern:</td>
                            <td class="text-end">{{ workarea.extra?.drill_length }} cm</td>
                        </tr>
                    </table>
                    <div class="fst-italic">{{ workarea.comments }}</div>
                </div>
            </div>
        }
    </div>
} @else {
    <div class="workarea-list general" [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
        @if (!filter.workarea && !workareaPerPage) {
            <h1>Details werkvakken</h1>
        }
        @for (workarea of filteredWorkareas; track workarea) {
            <div
                class="workarea"
                [class.break-after]="workareaPerPage"
                [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
                <div class="title">
                    <h2>
                        Werkvak {{ workarea.number }} - {{ workarea.street }} {{ workarea.housenumber }},
                        {{ workarea.zipcode }} {{ workarea.place }}
                    </h2>
                    <h4>
                        <a
                            href="http://www.google.com/maps/place/{{ workarea.lat }},{{ workarea.lng }}"
                            target="_blank">
                            {{ workarea.lat }}, {{ workarea.lng }}
                        </a>
                        @if (workarea.road_number) {
                            Wegnummer: {{ workarea.road_number }}
                        }
                    </h4>
                </div>
                @if (workarea.images?.length > 0) {
                    <div class="image">
                        @for (image of workarea.images; track image) {
                            <img src="{{ image.image_url }}?thumb=true" class="float-start" />
                        }
                    </div>
                }
                <div class="details w-100">
                    <div class="fst-italic" [innerHTML]="workarea.comments | nl2br"></div>
                    <div class="row pt-2">
                        <div class="col-12">
                            <table [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
                                <tr>
                                    <td>Status:</td>
                                    <td>{{ workarea?.status_name }}</td>
                                </tr>
                                <tr>
                                    <td width="140">Locatie:</td>
                                    <td>{{ workarea.extra?.location_damage }}</td>
                                </tr>
                                <tr>
                                    <td>Type:</td>
                                    <td>{{ workarea.extra?.damage }}</td>
                                </tr>
                                <tr>
                                    <td>Schade Locatie:</td>
                                    <td>{{ workarea.extra?.location_damage }}</td>
                                </tr>
                                <tr>
                                    <td>Klinkervak:</td>
                                    <td>{{ workarea.extra?.klinkerfloor ? 'Ja' : 'Nee' }}</td>
                                </tr>
                                <tr>
                                    <td>Bewapeningsnet:</td>
                                    <td>{{ workarea.extra?.reinforcementgrid ? 'Ja' : 'Nee' }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>Toplaag:</td>
                                    <td>{{ workarea.extra?.toplayer }}</td>
                                </tr>
                                <tr>
                                    <td>Tussenlaag:</td>
                                    <td>{{ workarea.extra?.interlayer }}</td>
                                </tr>
                                <tr>
                                    <td>Onderlaag:</td>
                                    <td>{{ workarea.extra?.bottomlayer }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-12">
                            <table [ngClass]="pdfStyleKey ? 'pdf-style-' + pdfStyleKey : ''">
                                <tr>
                                    <td>Wegmarkering:</td>
                                    <td>{{ workarea.extra?.waymark }}</td>
                                </tr>
                                <tr>
                                    <td>Wegafzetting:</td>
                                    <td>{{ workarea.extra?.roadblock }}</td>
                                </tr>
                                <tr>
                                    <td>Uitvoering:</td>
                                    <td>{{ workarea.extra?.execution }}</td>
                                </tr>
                                <tr>
                                    <td>Prioriteit:</td>
                                    <td>{{ workarea.extra?.genpriority }}</td>
                                </tr>
                                <tr>
                                    <td>Afzetting:</td>
                                    <td>{{ workarea.extra?.roadblock }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colspan="2">&nbsp;</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="p-0">
                                        @if (workarea.areas?.length) {
                                            <table>
                                                <tr>
                                                    <th>Lengte</th>
                                                    @if (workarea.extra.damage != 'Scheuren') {
                                                        <th>Breedte</th>
                                                    }
                                                    <th width="250">Oppervlakte</th>
                                                </tr>
                                                @for (area of workarea.areas; track area; let i = $index) {
                                                    <tr>
                                                        <td>{{ area.length }} m</td>
                                                        @if (workarea.extra.damage != 'Scheuren') {
                                                            <td>{{ area.width }} m</td>
                                                        }
                                                        <td class="col-12 col-md-12 d-flex">
                                                            <div>
                                                                {{ area.width * area.length | number: '0.0-2' }} m
                                                                @if (workarea.extra.damage != 'Scheuren') {
                                                                    <sup>2</sup>
                                                                }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                                <tr>
                                                    <td>
                                                        <b>Totaal:</b>
                                                    </td>
                                                    @if (workarea.extra.damage !== 'Scheuren') {
                                                        <td></td>
                                                    }
                                                    <td>
                                                        {{ areasTotal(workarea.areas) | number: '0.0-2' }} m<sup>2</sup>
                                                    </td>
                                                </tr>
                                            </table>
                                        }
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}
